module.exports = __webpack_public_path__ + "static/media/text_title_sh.efb2ac7f.svg";